var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarehouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.30336 7.87335H10.6434V8.67335H9.30336V7.87335Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6434 7.87335H11.3034V8.67335H12.6434V7.87335Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.30336 9.87335H10.6434V10.6733H9.30336V9.87335Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6434 9.87335H11.3034V10.6733H12.6434V9.87335Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.30336 7.87335H6.64336V8.67335H5.30336V7.87335Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.64336 7.87335H7.30336V8.67335H8.64336V7.87335Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.30336 9.87335H6.64336V10.6733H5.30336V9.87335Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64336 7.87335H3.30336V8.67335H4.64336V7.87335Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.30336 9.87335H4.64336V10.6733H3.30336V9.87335Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.64336 9.87335H7.30336V10.6733H8.64336V9.87335Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.23669 12.6667H14.71L14.7 3.51668L14.2367 3.18335L10.7034 4.95668V3.54668L10.25 3.21335L6.37336 5.00002V3.53668L5.90336 3.20335L1.23669 5.70335V12.6667ZM13.91 11.8667H2.04336L2.03669 6.18002L5.57669 4.28668V6.23002L9.91003 4.25002V6.25002L13.91 4.25002V11.8667Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouse);
export default __webpack_public_path__ + "static/media/warehouse.42a11a57b19f6945176e0dca7cc94037.svg";
export { ForwardRef as ReactComponent };